import React from "react";
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Container,
} from "@mui/material";
import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import api from "_api";

const ModalBorrow = ({ open, onClose, selectedProduct }) => {
  const handleCancel = () => {
    onClose();
  };

  const handlePrintPDF = async () => {
    if (selectedProduct) {
      await api.product
        .getPrintPdfLendOrderOne(selectedProduct?.id)
        .then((res) => {
          const url = window.URL.createObjectURL(
            new Blob([res.data], { type: "application/pdf" })
          );
          window.open(url, "_blank");
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        borderRadius: "12px",
      }}
    >
      <DialogTitle>
        <Typography variant="h4">พิมพ์ใบยืมคืน</Typography>
      </DialogTitle>
      <DialogContent sx={{ padding: 0 }}>
        <Container
          sx={{
            display: "flex", // Use flexbox to layout the children
            flexDirection: "column", // Arrange items in a column (vertical)
            alignItems: "center", // Center items horizontally
            justifyContent: "center", // Center items vertically
          }}
        >
          <GradientButton
            variant="outlined"
            sx={{ mb: 1 }} // Add margin-bottom to separate buttons vertically
            onClick={handleCancel}
          >
            พิมพ์ขนาด A4 แนวนอน (ตัดครึ่ง)
          </GradientButton>
          <GradientButton
            variant="outlined"
            sx={{ mb: 1 }}
            onClick={handlePrintPDF}
          >
            พิมพ์ขนาด A5 แนวนอน (ตัดครึ่ง)
          </GradientButton>
          <GradientButton variant="outlined" onClick={handleCancel}>
            พิมพ์กระดาษขนาด 80 mm
          </GradientButton>
        </Container>
      </DialogContent>

      <DialogActions sx={{ p: 3 }}>
        <GradientButtonOutline
          variant="outlined"
          sx={{ mr: 1 }}
          onClick={handleCancel}
        >
          กลับ
        </GradientButtonOutline>
      </DialogActions>
    </Dialog>
  );
};

export default ModalBorrow;
